import { FunctionComponent } from 'react';

import { Button, Text } from '@kanda-libs/ks-design-library';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import { LINE_3 } from './constants';
import useReadyToStart from './useReadyToStart';

const ReadyToStart: FunctionComponent = () => {
  const {
    title,
    subtitle,
    line2,
    companyName,
    successUrl,
    isExampleJob,
    isLoading,
    exampleReturnUrl,
  } = useReadyToStart();

  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      title={title}
      labelLine1={<AlternatingText array={subtitle} />}
      labelLine2={line2}
      labelLine3={LINE_3}
      isLoading={isLoading}
      footer={
        <>
          {isExampleJob && !successUrl && !isLoading && (
            <a href={exampleReturnUrl}>
              <Button.Text
                id="example-job"
                label="Back to dashboard"
                size={40}
                className="mt-4"
                isLoading={isLoading}
              />
            </a>
          )}
          {successUrl && !isLoading && (
            <>
              <Text
                text={`You will be automatically redirected back to ${companyName}'s website in 10 seconds. If you would like to return immediately, please click the below button.`}
                className="mb-4 text-14-22 text-neutral-600 md:mb-6"
                isLoading={isLoading}
              />
              <a href={successUrl} className="mx-auto">
                <Button.Text
                  id="ready-to-start-return-to-website"
                  label="Return to website"
                  isLoading={isLoading}
                />
              </a>
            </>
          )}
        </>
      }
    />
  );
};

export default ReadyToStart;
